import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import SimpleHeader from '../layouts/SimpleHeader'
import SideMenu from '../layouts/SideMenu'
import Modal from '../layouts/Modal'
import { useQuery } from '@apollo/client'
import {
  GET_TRACKER_CODE_QUERY,
  GET_POSTBACK_CODE_QUERY,
  GET_USERDATA_QUERY,
} from '../services/GraphQLQueries'
import MenuWrap from '../components/BurgerMenu/MenuWrap'
import LoadingPage from './LoadingPage'

const Settings = () => {
  const navigate = useNavigate()
  const [isLandingModalOpen, setIsLandingModalOpen] = useState(false)
  const [isPostbackModalOpen, setIsPostbackModalOpen] = useState(false)
  const [isPostbackButtonModalOpen, setIsPostbackButtonModalOpen] = useState(false)

  const trackerCodeResponse = useQuery(GET_TRACKER_CODE_QUERY)
  const postbackCodeResponse = useQuery(GET_POSTBACK_CODE_QUERY)
  const userDataResponse = useQuery(GET_USERDATA_QUERY)
  const snippetsLoading =
    trackerCodeResponse.loading ||
    postbackCodeResponse.loading ||
    userDataResponse.loading
  const userData = userDataResponse.data?.userdata
  const adminDisplayName =
    userData?.fullName?.trim() || userData?.email?.trim() || 'Account user'

  const copyCode = async (e) => {
    e.preventDefault()
    if (snippetsLoading) {
      return
    }

    let copyValue = ''
    if (e.target.id === 'copyTracker') {
      copyValue = trackerCodeResponse.data?.trackerCode || ''
    } else if (e.target.id === 'copyPostback') {
      copyValue = postbackCodeResponse.data?.postbackCode.pagePostback || ''
    } else {
      copyValue = postbackCodeResponse.data?.postbackCode.buttonPostback || ''
    }

    if (!copyValue) {
      return
    }

    await navigator.clipboard.writeText(copyValue)
    let span = document.getElementById(e.target.id + 'Message')
    if (!span) {
      return
    }
    span.style.zIndex = 999
    span.style.animation = 'fade 2s forwards'
    setTimeout(() => {
      span.style.animation = ''
      span.style.zIndex = -1
    }, 2000)
  }

  if (snippetsLoading) {
    return <LoadingPage />
  }

  return (
    <div id="outer-container" style={{ height: '100%' }}>
      <MenuWrap className="sm:hidden">
        <SideMenu isAuthorized={true}></SideMenu>
      </MenuWrap>
      <div id="page-wrap">
        <div className="flex">
          <SideMenu isAuthorized={true} className="hidden sm:block"></SideMenu>
          <div className="w-full">
            <SimpleHeader />
            <div className="h-[calc(100vh-175px)]" aria-live="polite">
              <div className="flex items-center h-full">
                <div className="grid grid-cols-12 gap-3 mb-6 w-full">
                  <h1 className="rounded-2xl col-start-4 col-end-10 w-full font-unbounded text-lg font-bold text-onTrack-smoke text-start mx-auto bg-metrinome-shadow-green py-4 pl-6">
                    Admin
                  </h1>

                  <div className="flex items-center justify-between rounded-2xl p-4 relative col-start-4 col-end-10 border border-[#FAD070] mb-4 h-12">
                    <p className="left-6 text-lg text-onTrack-smoke">
                      {`${adminDisplayName}, Password`}
                    </p>
                    <button
                      type="button"
                      className="right-6 text-lg text-onTrack-smoke cursor-pointer bg-transparent"
                      onClick={() => navigate('/change-password')}
                    >
                      {'<edit>'}
                    </button>
                  </div>

                  <h1 className="rounded-2xl col-start-4 col-end-10 w-full font-unbounded text-lg font-bold text-onTrack-smoke text-start mx-auto bg-metrinome-shadow-green py-4 pl-6">
                    Payment
                  </h1>

                  <div className="flex items-center justify-between rounded-2xl p-4 relative col-start-4 col-end-10 border border-[#FAD070] mb-4 h-12">
                    <p className="left-6 text-lg text-onTrack-smoke">{'Account summary'}</p>
                    <p
                      className="absolute right-6 text-lg text-onTrack-smoke cursor-pointer"
                      onClick={() => navigate('/account-summary')}
                    >
                      {'<open>'}
                    </p>
                  </div>

                  <div className="flex items-center justify-between rounded-2xl p-4 relative col-start-4 col-end-10 border border-[#FAD070] mb-4 h-12">
                    <p className="left-6 text-lg text-onTrack-smoke">{'Manage your subscription'}</p>
                    <p
                      className="absolute right-6 text-lg text-onTrack-smoke cursor-pointer"
                      onClick={() => navigate('/select-plan')}
                    >
                      {'<manage>'}
                    </p>
                  </div>

                  <h1 className="rounded-2xl col-start-4 col-end-10 w-full font-unbounded text-lg font-bold text-onTrack-smoke text-start mx-auto bg-metrinome-shadow-green py-4 pl-6">
                    Snippets
                  </h1>

                  {/* LANDING PAGE SNIPPET */}
                  <div className="flex items-center justify-between rounded-2xl p-4 relative col-start-4 col-end-10 border border-[#FAD070] h-12">
                    <p className="left-6 text-lg text-onTrack-smoke">{'Landing Page Snippet'}</p>
                    <p className="absolute right-6 text-lg text-onTrack-smoke cursor-pointer" onClick={() => setIsLandingModalOpen(true)}>
                      {'<show>'}
                    </p>
                  </div>

                  {/* THANK YOU PAGE SNIPPET */}
                  <div className="flex items-center justify-between rounded-2xl p-4 relative col-start-4 col-end-10 border border-[#FAD070] h-12">
                    <p className="left-6 text-lg text-onTrack-smoke">{'Thank You Page Snippet'}</p>
                    <p className="absolute right-6 text-lg text-onTrack-smoke cursor-pointer" onClick={() => setIsPostbackModalOpen(true)}>
                      {'<show>'}
                    </p>
                  </div>

                  {/* CONFIRM BUTTON SNIPPET */}
                  <div className="flex items-center justify-between rounded-2xl p-4 relative col-start-4 col-end-10 border border-[#FAD070] h-12">
                    <p className="left-6 text-lg text-onTrack-smoke">{'Confirm Button Snippet'}</p>
                    <p className="absolute right-6 text-lg text-onTrack-smoke cursor-pointer" onClick={() => setIsPostbackButtonModalOpen(true)}>
                      {'<show>'}
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* ---------- LANDING MODAL ---------- */}
            {isLandingModalOpen && (
              <Modal setIsModalOpen={setIsLandingModalOpen} backGroundClass={'darkBG'}>
                <div className="modalContent mx-auto p-3 max-w-[90vw]">
                  <p className="w-full text-l text-[#000000] text-center mx-auto font-unbounded mb-4">
                    {'Paste this code as high in the <head> of the page as possible'}
                  </p>

                  <div className="w-full overflow-x-auto">
                    <pre className="text-xs text-black text-left p-4 border border-onTrack-light-purple rounded-lg bg-white whitespace-pre-wrap break-all leading-relaxed font-mono">
                      <code>{trackerCodeResponse.data?.trackerCode}</code>
                    </pre>
                  </div>

                  <div className="relative mt-4 flex justify-center">
                    <span id="copyTrackerMessage" className="tooltiptext left-[41%] bottom-[100%] w-[10vw]">
                      Copied to clipboard
                    </span>
                    <button
                      id="copyTracker"
                      onClick={copyCode}
                      className="bg-[#FAD070] text-black font-unbounded text-base py-2 px-6 rounded-lg shadow-md hover:bg-[#f7c647] transition"
                    >
                      Copy the code
                    </button>
                  </div>

                  <div className="modalActions mt-4 flex justify-center">
                    <button
                      className="py-2 px-6 font-unbounded rounded-lg text-black bg-[#FAD070] hover:bg-[#f7c647]"
                      onClick={() => setIsLandingModalOpen(false)}
                    >
                      Close
                    </button>
                  </div>
                </div>
              </Modal>
            )}

            {/* ---------- POSTBACK MODAL ---------- */}
            {isPostbackModalOpen && (
              <Modal setIsModalOpen={setIsPostbackModalOpen} backGroundClass={'darkBG'}>
                <div className="modalContent mx-auto p-3 max-w-[90vw]">
                  <p className="w-full text-l text-[#000000] text-center mx-auto font-unbounded mb-4">
                    {'Paste this code as high in the <head> of the thank you page as possible'}
                  </p>

                  <div className="w-full overflow-x-auto">
                    <pre className="text-xs text-black text-left p-4 border border-[#FAD070] rounded-lg bg-white whitespace-pre-wrap break-all leading-relaxed font-mono">
                      <code>{postbackCodeResponse.data?.postbackCode.pagePostback}</code>
                    </pre>
                  </div>

                  <div className="relative mt-4 flex justify-center">
                    <span id="copyPostbackMessage" className="tooltiptext left-[41%] bottom-[100%] w-[10vw]">
                      Copied to clipboard
                    </span>
                    <button
                      id="copyPostback"
                      onClick={copyCode}
                      className="bg-[#FAD070] text-black font-unbounded text-base py-2 px-6 rounded-lg shadow-md hover:bg-[#f7c647] transition"
                    >
                      Copy the code
                    </button>
                  </div>

                  <div className="modalActions mt-4 flex justify-center">
                    <button
                      className="py-2 px-6 font-unbounded rounded-lg text-black bg-[#FAD070] hover:bg-[#f7c647]"
                      onClick={() => setIsPostbackModalOpen(false)}
                    >
                      Close
                    </button>
                  </div>
                </div>
              </Modal>
            )}

            {/* ---------- CONFIRM BUTTON MODAL ---------- */}
            {isPostbackButtonModalOpen && (
              <Modal setIsModalOpen={setIsPostbackButtonModalOpen} backGroundClass={'darkBG'}>
                <div className="modalContent mx-auto p-3 max-w-[90vw]">
                  <p className="w-full text-l text-[#000000] text-center mx-auto font-unbounded mb-4">
                    {
                      'Paste this code as high in the <head> of the purchase page as possible and change the "{id}" in code with purchase button\'s id'
                    }
                  </p>

                  <div className="w-full overflow-x-auto">
                    <pre className="text-xs text-black text-left p-4 border border-[#FAD070] rounded-lg bg-white whitespace-pre-wrap break-all leading-relaxed font-mono">
                      <code>{postbackCodeResponse.data?.postbackCode.buttonPostback}</code>
                    </pre>
                  </div>

                  <div className="relative mt-4 flex justify-center">
                    <span id="copyConfirmMessage" className="tooltiptext left-[41%] bottom-[100%] w-[10vw]">
                      Copied to clipboard
                    </span>
                    <button
                      id="copyConfirm"
                      onClick={copyCode}
                      className="bg-[#FAD070] text-black font-unbounded text-base py-2 px-6 rounded-lg shadow-md hover:bg-[#f7c647] transition"
                    >
                      Copy the code
                    </button>
                  </div>

                  <div className="modalActions mt-4 flex justify-center">
                    <button
                      className="py-2 px-6 font-unbounded rounded-lg text-black bg-[#FAD070] hover:bg-[#f7c647]"
                      onClick={() => setIsPostbackButtonModalOpen(false)}
                    >
                      Close
                    </button>
                  </div>
                </div>
              </Modal>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default Settings
